export default "__VITE_ASSET__GRBcmvzW__"